// extracted by mini-css-extract-plugin
module.exports = {"picture":"image_picture__XDkgs","image":"image_image__lootM","cover":"image_cover__yidfM","contain":"image_contain__yoYwm"};